import { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import ParallaxProvider from 'components/ParallaxWrapperFiber/ParallaxProvider';
import ParallaxEnabler from 'components/ParallaxWrapperFiber/ParallaxEnabler';
import Hero from './components/Hero';
import Features from './components/Features';
import { HomeContainer, SectionsLoading } from './styled';

const Footer = lazy(() => import('components/Footer'));
// Uncomment to show pricing section (company-signup) (1/2)
// Also edit `useHandleCompanySignup` hook to enable scrolling to the pricing section
// const Pricing = lazy(() => import('./components/Pricing'));
const Coverage = lazy(() => import('./components/Coverage'));
const Product = lazy(() => import('./components/Product'));
const Benefits = lazy(() => import('./components/Benefits'));
const Disclaimer = lazy(() => import('./components/Disclaimer'));
const CallToAction = lazy(() => import('./components/CallToAction'));
const Testimonials = lazy(() => import('./components/Testimonials'));

const Home = () => {
  return (
    <ParallaxProvider>
      <HomeContainer>
        <Helmet>
          <title>Remote Health for remote companies</title>
          <meta
            name="description"
            content="Global health insurance for global and distributed teams."
          />
          <link rel="canonical" href="https://safetywing.com/remote-health" />
        </Helmet>

        <ParallaxEnabler />

        {/* Sections */}
        <Hero />
        <Features />

        <Suspense fallback={<SectionsLoading />}>
          {/* Uncomment to show pricing section (company-signup) (2/2) */}
          {/* <Pricing /> */}
          <Coverage />
          <Product />
          <Benefits />
          <CallToAction />
          <Disclaimer />
          <Testimonials />
          <Footer />
        </Suspense>
      </HomeContainer>
    </ParallaxProvider>
  );
};

export default Home;
